function getParamUrl(param) {
  const url = new URL(window.location.href);
  const value = url.searchParams.get(param);
  return value;
}

export default getParamUrl;
